export type Addendum = { id: string; text: string };

export enum AddendumStatus {
  PENDING = "Pending",
  ACCEPTED = "Accepted",
}

/**
 * Narrows a free-form display string (e.g. from getDisplay(codeableConcept))
 * to a valid AddendumStatus, or undefined if it doesn't match. Keep the
 * comparison sites that depend on AddendumStatus.* type-safe.
 */
export const parseAddendumStatus = (
  display: string | undefined,
): AddendumStatus | undefined => {
  if (
    display === AddendumStatus.PENDING ||
    display === AddendumStatus.ACCEPTED
  ) {
    return display;
  }
  return undefined;
};
